import { SolutionType } from '../../shared/constants/user-info/solutionType';
import { apiService } from '../../shared/services/apiService';
import { SearchCustomerResult } from '../interfaces/SearchCustomerResult';

export const searchService = {
  async searchCustomer(
    query: string,
    solutionType: SolutionType,
  ): Promise<SearchCustomerResult[]> {
    const resp = await apiService.get<SearchCustomerResult[]>(
      '/api/home-page/customers/search',
      { params: { query, customerType: solutionType }, isRunGlobalSpinner: false },
    );

    return resp.data;
  },
};
